import { useCompanyFspVM } from "presentation/hook/Company/useCompanyFspVM";
import { useCompanyDetailTracked } from "presentation/store/Company/CompanyDetailProvider";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { FieldType, IFieldValue } from "veronica-ui-component/dist/component/core";

export const CalendarAdjAccordion = () => {
    const [companyDetailState] = useCompanyDetailTracked();
    const { calendarAdj } = companyDetailState.companyFspState;
    const CompanyFspVM = useCompanyFspVM();
    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item' style={{ width: "14vw" }}>
                    <NbisCommonField
                        errorMessages={companyDetailState?.allFormState}
                        isReadOnly={false}
                        isShowOptional={false}
                        readOnlyValue={calendarAdj?.join(',')}
                        fieldValue={calendarAdj}
                        fieldLabel={"Calendar Adj."}
                        isSaveClicked={false}
                        fieldType={FieldType.DROPDOWN}
                        fieldKey={'calendarAdj'}
                        maxLength={60}
                        isMultipleDropDown={true}
                        options={companyDetailState.dynamicOptions.calendarAdjDropdownOptions}
                        requiredFieldList={[]}
                        onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                            CompanyFspVM.onCompanyFSPFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
                </div>

            </div>
            {companyDetailState.forceRefresh && <></>}
        </>
    )
}